module.exports = __webpack_public_path__ + "img/stable64_ua.6fb1f6e3.webp";